module.exports = __webpack_public_path__ + "static/img/dress_medal_default.1f50359a.png";